<input
  class="peer sr-only"
  [type]="base.inputType()"
  [id]="base.id()"
  [checked]="base.isChecked()"
  [attr.name]="base.resolvedName()"
  [attr.value]="base.value()"
  [disabled]="base.isDisabled()"
  (change)="base.onInputChange($event)"
  (click)="base.onInputClick()"
/>
<label [class]="labelClasses" [for]="base.id()">
  <ng-content />
</label>
